'use client';

import { Link } from '@/components/ui/link/link.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export interface FooterLinkProps {
  href: string;
  titleLink: string;
  targetBlank?: boolean;
}

export function FooterLinkItem({
  href,
  titleLink,
  targetBlank,
}: FooterLinkProps) {
  const isInternalLink
    = !targetBlank && typeof href === 'string' && href.startsWith('/');

  return (
    <li>
      <Link
        prefetch={false}
        href={href}
        className="hover:underline"
        data-analytics-event={AnalyticsEnum.CLICK_FOOTER_ITEM}
        data-analytics-properties={JSON.stringify({ item_footer: titleLink })}
        target={targetBlank ? '_blank' : '_self'}
        data-footer-link={isInternalLink ? 'true' : undefined}
      >
        {titleLink}
      </Link>
    </li>
  );
}
